module.exports = {
          srcSet: "/_next/static/images/logo-orange_original-80-57322a7b549160f714a8bc4fad7460fb.png"+" 80w"+","+"/_next/static/images/logo-orange_original-50-0e3955af44d9c6057e56ea5054823816.png"+" 50w",
          images:[ {path: "/_next/static/images/logo-orange_original-80-57322a7b549160f714a8bc4fad7460fb.png",width: 80,height: 71},{path: "/_next/static/images/logo-orange_original-50-0e3955af44d9c6057e56ea5054823816.png",width: 50,height: 44}],
          src: "/_next/static/images/logo-orange_original-80-57322a7b549160f714a8bc4fad7460fb.png",
          toString:function(){return "/_next/static/images/logo-orange_original-80-57322a7b549160f714a8bc4fad7460fb.png"},
          
          width: 80,
          height: 71
        }